import React from "react";
import {toDate} from "date-fns";
import {DATE_FORMAT} from "@reside/ui";

import {
  AdmissionId,
  CellFooter,
  CellIdentityBlock,
  CellLastUpdatePrefix,
  CellLastUpdateRow,
  CellLastUpdateTime,
  CellResidentNameLink,
  DashboardCell,
  Left,
  Right,
} from "../../../../dashboard-cell";
import {RelativeDateTime} from "../../../../relative-date-time";
import {WorkflowRibbon} from "../../../../dashboard-cell/WorkflowRibbon";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";

import {PdfUploadStatusIcon} from "../../pdf-upload-status-icon";
import {TriggeredWorkflowIcon} from "../../triggered-workflow-icon";
import {getAdmissionResidentName, getResidentTestId} from "../../../helper";
import {ApproveAdmissionFooterButton} from "./ApproveAdmissionDropdownItem";
import {SignedSplitButton} from "./SignedSplitButton";
import {AdmissionChecklist} from "../admission-checklist";
import {StarAdmissionIcon} from "../../../../star-icon/StarAdmissionIcon";
import {getAdmissionViewHref} from "../../../../dashboard-cell/admissionRoutes";

type Props = Readonly<{
  admission: AdmissionFromSearch;
}>;

export const AdmissionSignedCell = ({admission}: Props) => {
  const updatedAt = toDate(admission.updated * 1000);

  return (
    <DashboardCell admissionHref={getAdmissionViewHref(admission.id)}>
      <WorkflowRibbon
        workflowType={admission.workflowType}
        star={
          <StarAdmissionIcon
            workflowType={admission.workflowType}
            admissionId={admission.id}
            isStarred={admission.starred}
          />
        }
        actions={<SignedSplitButton admission={admission} />}
      />
      <CellIdentityBlock>
        <CellResidentNameLink
          name={getAdmissionResidentName(admission)}
          residentId={admission.residentId}
          data-test-id={getResidentTestId(admission, "editProfile")}
        />
        <AdmissionId code={admission.code} />
      </CellIdentityBlock>
      <AdmissionChecklist admission={admission} />

      {admission.sourceWorkflowId ? (
        <TriggeredWorkflowIcon workflowType={admission.workflowType} />
      ) : null}

      <CellFooter>
        <Left>
          <CellLastUpdateRow>
            <CellLastUpdatePrefix>Last update:</CellLastUpdatePrefix>
            <CellLastUpdateTime>
              <RelativeDateTime
                dateTime={updatedAt}
                dateFormat={DATE_FORMAT.DAY_IN_MONTH}
              />
            </CellLastUpdateTime>
          </CellLastUpdateRow>
        </Left>
        <Right>
          {admission.resources?.finalPdf?.pccUploadStatus ? (
            <PdfUploadStatusIcon
              pdfUploadStatus={
                admission.resources.finalPdf.pccUploadStatus as any
              }
            />
          ) : null}
          <ApproveAdmissionFooterButton admission={admission} />
        </Right>
      </CellFooter>
    </DashboardCell>
  );
};
